import { useState } from "react";
import "./index.scss";

const ContactForm = ({ title, resume }) => {
  const [formInfo, setFormInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    sender: "",
    message: "",
    attachment: "",
  });

  const handleChange = ({ target }) => {
    const { value, name } = target;
    setFormInfo({ ...formInfo, [name]: value });
  };
  const currentPage = window.location.href;
  const currentPagePath = window.location.pathname;
  const successPage = currentPage.replace(currentPagePath, "/success");

  return (
    <div className="careers-form">
      <div className="container">
        <div className="title">{title}</div>
        <form
          autoComplete="off"
          method="POST"
          action="https://formsubmit.co/info@omniactive.com"
          encType="multipart/form-data"
        >
          <div className="group">
            <label className="form-input-label">
              First Name <div className="required">*</div>
            </label>
            <input
              className="form-input"
              name="firstName"
              type="text"
              id="first-name"
              onChange={handleChange}
              value={formInfo.firstName}
              required
            />
          </div>

          <div className="group">
            <label className="form-input-label">
              Last Name <div className="required">*</div>
            </label>
            <input
              className="form-input"
              name="lastName"
              type="text"
              id="last-name"
              onChange={handleChange}
              value={formInfo.lastName}
              required
            />
          </div>

          <div className="group">
            <label className="form-input-label">
              Email <div className="required">*</div>
            </label>
            <input
              className="form-input"
              name="email"
              type="email"
              id="email"
              onChange={handleChange}
              value={formInfo.email}
              required
            />
          </div>

          <div className="group">
            <label className="form-input-label">
              I am a <div className="required">*</div>
            </label>
            <select
              className="form-input"
              name="sender"
              id="sender"
              onChange={handleChange}
              value={formInfo.sender}
              required
            >
              <option value="Potential Client">Potential Client</option>
              <option value="In-person trainer" defaultValue>
                In-person trainer
              </option>
              <option value="Online trainer">Online trainer</option>
              <option value="Fitness Marketing Specialist">Fitness Marketing Specialist</option>
              <option value="Sales Associate">Sales Associate</option>
            </select>
          </div>
          {resume && (
            <div className="group">
              <label className="form-input-label">Resume</label>
              <input
                className="form-input"
                name="attachment"
                type="file"
                id="attachment"
                accept=".doc,.pdf,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                onChange={handleChange}
                value={formInfo.attachment}
              />
            </div>
          )}

          <div className="group">
            <label className="form-input-label">
              Your Message <div className="required">*</div>
            </label>
            <textarea
              className="message"
              name="message"
              type="text"
              id="message"
              onChange={handleChange}
              value={formInfo.message}
              rows="10"
              required
            />
          </div>
          <input type="hidden" name="_next" value={successPage}></input>
          <input type="hidden" name="_captcha" value="false"></input>
          <div className="buttons">
            <button className="send-message-button" type="submit">
              Send your message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
